import React from 'react';
import { Box, Typography, Paper, styled } from '@mui/material';
import logo from 'app/images/IQ-Transparent.png';

const FallbackContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  height: '100vh',
  width: '100%',
  backgroundColor: theme.palette.background.default,
  padding: theme.spacing(4),
  boxSizing: 'border-box',
}));

const FallbackCard = styled(Paper)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  padding: theme.spacing(6),
  borderRadius: theme.spacing(2),
  boxShadow: '0 8px 32px rgba(0, 0, 0, 0.1)',
  backgroundColor: theme.palette.background.paper,
  maxWidth: 500,
  width: '100%',
  textAlign: 'center',
}));

const LogoContainer = styled(Box)(({ theme }) => ({
  width: 80,
  height: 80,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  marginBottom: theme.spacing(3),
}));

const LogoImage = styled('img')({
  width: '100%',
  height: '100%',
  objectFit: 'contain',
});

const Title = styled(Typography)(({ theme }) => ({
  fontSize: '1.5rem',
  fontWeight: 600,
  color: theme.palette.text.primary,
  marginBottom: theme.spacing(2),
}));

const Description = styled(Typography)(({ theme }) => ({
  fontSize: '1rem',
  color: theme.palette.text.secondary,
  marginBottom: theme.spacing(4),
  lineHeight: 1.6,
}));


const DealerSelectionFallback: React.FC = () => {

  return (
    <FallbackContainer>
      <FallbackCard elevation={3}>
        <LogoContainer>
          <LogoImage src={logo} alt="myautoiq Logo" />
        </LogoContainer>
        
        <Title>
          Select a Dealership
        </Title>
        
        <Description>
        To access the app’s features, please select a dealership from the dropdown menu at the top of the sidebar.
This will unlock all the powerful tools and insights tailored to your selected dealership.
        </Description>

      </FallbackCard>
    </FallbackContainer>
  );
};

export default DealerSelectionFallback;
